module.exports = __webpack_public_path__ + "img/02.51451abf.jpg";